define('vspot-angular/services/job-assignment-service',[], function () {
    'use strict';

    return ['resources.JobAssignmet', function (jobassignments) {
        return {

            /**
             * requestSwap:
             * @param accesskey access key of the current participant
             * @param activityId  id of the activity
             * @param jobAssId id of the job assignment the participant currently has
             * @param swapArray array of job assignment id's to request a swap with
             * @param message optional message to send with swap requests
             * @returns {*|{method, params}}
             */
            requestSwap: function (accessKey, activityId, jobAssId, swapArray, message) {
                return jobassignments.requestSwap({
                    accesskey:          accessKey,
                    activity_id:        activityId,
                    selected_activity:  activityId,
                    orig_jaid:          jobAssId,
                    new_jaids:          swapArray,
                    msg:                message
                });
            },


            /**
             * createJobAssignment:
             * @param accesskey  of the Assigner
             * @param activityId  of the activity
             * @param volunteerId of the Assignee
             * @param jobId of the job to be assigned
             * @param quantity to add
             * @returns {*|{method, params}}
             */
            createJobAssignment: function (accessKey, activityId, volunteerId, jobId, quantity) {


                // console.log('accessKey');
                // console.log(accessKey);
                // console.log('activityId');
                // console.log(activityId);
                // console.log('volunteerId');
                // console.log(volunteerId);
                // console.log('jobId');
                // console.log(jobId);
                // console.log('quantity');
                // console.log(quantity);



                return jobassignments.createJobAssignment({
                    accesskey:         accessKey,
                    activity_id:        activityId,
                    volunteer_id:       volunteerId,
                    selected_activity:  activityId,
                    quantity:           quantity,
                    job_id:             jobId
                });
            },



            /**
             * updateJobAssignment:
             * @param accesskey  of the Assigner
             * @param activityId  of the activity
             * @param quantity to add
             * @returns {*|{method, params}}
             */
            updateJobAssignment: function (accessKey, activityId, volunteerId, quantity, jobAssignmentId) {
                return jobassignments.updateJobAssignment({
                    accesskey:         accessKey,
                    activity_id:        activityId,
                    volunteer_id:       volunteerId,
                    selected_activity:  activityId,
                    quantity:           quantity,
                    id:                 jobAssignmentId
                });
            },

            /**
             *  Deletes a job assignment.
             *
             *  @param id         [REQUIRED] [INT]     The id of the job assignment.
             *  @param activityId [REQUIRED] [INT]     The activity id.
             *  @param accesskey  [REQUIRED] [STR]     The accesskey of the Assigner.
             */
            delete: function(accessKey, activityId, id) {
                return jobassignments.delete({
                    id:                 id,
                    activity_id:        activityId,
                    selected_activity:  activityId,
                    accesskey:          accessKey
                });
            }
        };
    }];
});

